document.addEventListener("DOMContentLoaded", () => {
  console.log("Script loaded")

  const overlay = document.querySelector(".floating-overlay");
  const sellingPlanID = overlay?.getAttribute("data-sellingPlanID");
  const cartDisplayName = overlay?.getAttribute("data-cartDisplayName");
  const upsellProductId = overlay?.getAttribute("data-upsellProduct");

  // Check if the button exists
  var new_mixAndMatchAtc = document.querySelector(".floating-overlay__atc")

  if (!new_mixAndMatchAtc) {
    console.error("Button with class '.floating-overlay__atc' not found!")
    return
  }

  console.log("Button found:", new_mixAndMatchAtc)

  var items = {}
  var cartItems = []
  var quantitySelector = document.querySelectorAll(".QuantitySelector__CurrentQuantity")

  console.log("Found quantity selectors:", quantitySelector.length)

  quantitySelector.forEach((elem) => {
    console.log("Setting up observer for:", elem)

    // Make sure the element has a dataset.sku
    if (!elem.dataset.sku) {
      console.warn("Element missing data-sku attribute:", elem)
      return
    }

    observeElement(elem, "value", (oldValue, newValue) => {
      var isAboPage = false
      var packageSize, pricePerMeal

      items[elem.dataset.sku] = Number.parseInt(newValue)
      console.log("Updated items:", items)
      updateTotals();
    })
  })



  const fullUrl = window.location.href;

  if (!fullUrl.includes('transactionId')) {

    // Add click event listener
    new_mixAndMatchAtc.addEventListener("click", async (e) => {

      const text = new_mixAndMatchAtc.querySelector('.floating-overlay__atc-text');
      const spinner = new_mixAndMatchAtc.querySelector('.spinner');

      if (text) text.style.display = 'none';
      if (spinner) spinner.style.display = 'block';

      e.preventDefault() // Prevent default action

      const boxSizesID = document
        .querySelector('.plan-card__button[data-checked="true"]')
        ?.getAttribute("data-boxSizesID")
      const discountID = document
        .querySelector('.plan-card__button[data-checked="true"]')
        ?.getAttribute("data-discountID")
      const discountCode = document
        .querySelector('.plan-card__button[data-checked="true"]')
        ?.getAttribute("data-discountCode")

      const discountCodes = []

      // Add the primary discount code from the selected plan
      if (discountCode) {
        discountCodes.push(discountCode)
      }

      discountCodes.push("FREE SHIPPING")

      // Remove duplicates in case the primary code is already "STRONGHABITSPLAN"
      const uniqueDiscountCodes = [...new Set(discountCodes)]

      console.log("Button clicked!    ", boxSizesID)
      const myHeaders = new Headers()
      myHeaders.append("Accept", "application/json")
      myHeaders.append("Content-Type", "application/json")

      const raw = JSON.stringify({
        boxSizeId: boxSizesID,
        productVariants: Object.entries(items).map(([id, qty]) => ({
          shopifyId: Number(id),
          quantity: qty,
        })),
        quantity: 1,
        sellingPlanShopifyId: Number(sellingPlanID),
        discountId: discountID,
      })

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      }

      const txnId = await createTransaction(requestOptions)

      if (txnId) {
        console.log("---- JACKPOT:", txnId)
        


        // Clear cartItems array before adding new items
        cartItems = []

        // Only add items with quantity > 0
        Object.keys(items).forEach((item) => {
          if (items[item] > 0) {
            cartItems.push({
              id: item,
              quantity: items[item],
              selling_plan: Number(sellingPlanID),
              properties: {
                _bundleId: txnId,
                __cartDisplayName: cartDisplayName,
                 ...(upsellProductId && { __linked_upsell: upsellProductId }),
              },
            })
          }
        })

        console.log("Cart items to add:", cartItems)

        if (cartItems.length === 0) {
          console.warn("No items to add to cart")
          return
        }

        try {

          if (upsellProductId){
            await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: upsellProductId,
                quantity: 1,
                properties: { _is_free_cart_upsell: true },
              }),
            })
          }

          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: cartItems,
            }),
          })

          if (!response.ok) {
            throw new Error("Failed to add items to cart")
          }

 

          if (uniqueDiscountCodes.length > 0) {
            console.log("Applying discount codes:", uniqueDiscountCodes)
            await tryDiscountCodes(uniqueDiscountCodes)
          } else {
            // No discount code, just go to cart
            //window.location.href = "/cart"
          }

          const res = await response.json()
          console.log("Successfully added to cart:", res)

          document.dispatchEvent(new CustomEvent("theme:loading:end"))

          res.items.forEach((item) => {
            document.dispatchEvent(
              new CustomEvent("product:added", {
                bubbles: true,
                detail: {
                  variant: item.variant_id,
                  quantity: item.quantity,
                },
              }),
            )
          })
        } catch (error) {
          console.error("Error:", error)
          document.dispatchEvent(new CustomEvent("theme:loading:end"))
        }
      }

      if (text) text.style.display = 'block';
      if (spinner) spinner.style.display = 'none';
    })
  } else {

    new_mixAndMatchAtc.addEventListener("click", async (e) => {
      const text = new_mixAndMatchAtc.querySelector('.floating-overlay__atc-text');
      const spinner = new_mixAndMatchAtc.querySelector('.spinner');

      if (text) text.style.display = 'none';
      if (spinner) spinner.style.display = 'block';
      e.preventDefault() // Prevent default action

      const boxSizesID = document
        .querySelector('.plan-card__button[data-checked="true"]')
        ?.getAttribute("data-boxSizesID")
      const discountID = document
        .querySelector('.plan-card__button[data-checked="true"]')
        ?.getAttribute("data-discountID")

      console.log("Button clicked!    ", boxSizesID)

      var tempHeader = "Bearer " + params.token

      const myHeaders = new Headers()
      myHeaders.append("Authorization", tempHeader)
      myHeaders.append("Accept", "application/json")
      myHeaders.append("Content-Type", "application/json")




      const raw = JSON.stringify({
        id: params.transactionId,
        items: Object.entries(items)
          .filter(([_, qty]) => qty > 0)
          .map(([id, qty]) => ({
            productVariantShopifyId: Number(id),
            quantity: qty,
          })),
        discountId: discountID,
        boxSizeId: boxSizesID,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      }

      const txnId = await updateSubscription(requestOptions)

      if (txnId) {
        console.log("---- JACKPOT:", txnId)
        
        if (window.returnUrl) {
          window.location.href = window.returnUrl;
        } else {
          window.location.href = "/account"
        }
      }
    })
  }

})  

// Make sure you have the observeElement function defined
function observeElement(element, property, callback, delay = 0) {
  const elementPrototype = Object.getPrototypeOf(element)
  if (elementPrototype.hasOwnProperty(property)) {
    const descriptor = Object.getOwnPropertyDescriptor(elementPrototype, property)
    Object.defineProperty(element, property, {
      get: function () {
        return descriptor.get.apply(this, arguments)
      },
      set: function () {
        const oldValue = this[property]
        descriptor.set.apply(this, arguments)
        const newValue = this[property]
        if (typeof callback == "function") {
          setTimeout(callback.bind(this, oldValue, newValue), delay)
        }
        return newValue
      },
    })
  }
}

async function createTransaction(requestOptions) {
  try {
    // Get the bundle ID from the DOM element
    const overlay = document.querySelector(".floating-overlay");
    const bundleId = overlay?.getAttribute("data-bundleID");

    if (!bundleId) {
      console.error("No bundle ID found on .floating-overlay");
      return;
    }

    const response = await fetch(
      `https://api.loopsubscriptions.com/storefront/2023-10/bundle/${bundleId}/transaction`,
      requestOptions
    );

    const result = await response.json()
    const txnId = result?.data?.txnId

    console.log("Full Response:", result)
    return txnId

  } catch (error) {
    console.error(error)
  }
}

async function updateSubscription(requestOptions) {
  try {
    const response = await fetch(
      "https://api.loopsubscriptions.com/storefront/2023-10/bundle/transaction/update",
      requestOptions,
    )
    const result = await response.json()
    console.log("Full Response:", result)
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

async function applyDiscountToCart(discountCode) {
  try {
    // First, navigate to discount URL to apply it
    const response = await fetch(`/discount/${discountCode}`, {
      method: "GET",
      redirect: "manual",
    })

    // Check if the discount was applied successfully
    if (response.status === 302 || response.status === 200) {
      // Then update cart to reflect changes
      const cartResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            discount_code: discountCode,
          },
        }),
      })

      const updatedCart = await cartResponse.json()
      console.log("Cart updated with discount:", updatedCart)

      return true // Success
    } else {
      console.log(`Discount code ${discountCode} not valid`)
      return false // Failed
    }
  } catch (error) {
    console.error("Error applying discount:", error)
    return false // Failed
  }
}

async function tryDiscountCodes(discountCodes) {
  for (const code of discountCodes) {
    console.log("Trying discount code:", code)
    const success = await applyDiscountToCart(code)

    if (success) {
      console.log(`Successfully applied discount code: ${code}`)
      // Refresh cart display only on success
      location.reload()
      return // Stop trying other codes
    } else {
      console.log(`Failed to apply discount code: ${code}, trying next...`)
      // Continue to next code
    }
  }

  // If no discount codes worked, just go to cart
  console.log("No discount codes worked, redirecting to cart")
  //window.location.href = "/cart"
}
